import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function AdminLayout() {

  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState({
    title: "",
    subtitle: "",
    description: "",
    video: "", 
  });

  const [videoFile, setVideoFile] = useState(null);
  const fetchBanner = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/hero/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setBanner(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  const location = useLocation();
  const pageTitles = {
    "/": "Form Ajuan",
    "/admin/": "Halaman Admin",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
    "/updateRf/": "Update Ajuan",
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const updateBanner = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("title", banner.title);
      formData.append("description", banner.description);

      // append video jika ada
      if (videoFile) {
        formData.append("video", videoFile);
      }

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/hero/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Data berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };

  const onChangeBanner = (e) => {
    const { name, value } = e.target;

    setBanner((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeBannerVideo = (e) => {
    const file = e.target.files[0];

    if (file) {    
      setVideoFile(file);
    }
  };  

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col pb-4'>
              <div className='p-4 text-xl font-medium'>
                Section Banner
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Title</label>
                  <input
                    name='title'
                    type="text"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={banner?.title}
                    onChange={onChangeBanner}
                    required
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Description</label>
                  <textarea
                    name='description'
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={banner?.description}
                    onChange={onChangeBanner}
                    required
                    rows={4}
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Video Background</label>
                  <input
                    type="file"
                    name='video'
                    accept="video/*"
                    onChange={onChangeBannerVideo}
                    className="block w-full text-sm file:mr-4 file:py-2 file:px-4
                    file:rounded-md file:border-0
                    file:bg-blue-600 file:text-white
                    hover:file:bg-blue-700 mb-4"
                  />  
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateBanner} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>
            </div>
            {/* 
              
             */}
          </div>
        </div>
      </section>
      
    </div>
  );
}

export default AdminLayout;
